import anime from "animejs";

import { $, body } from "@utils/dom";
import { moduleDelays } from "./utils";

const SELECTOR = "[data-site-loader]";

class SiteLoader {
  constructor() {
    this.el = $(SELECTOR);
  }

  loaded() {
    moduleDelays(350, 250);
  }

  ready() {
    // add class on body when transition is ready
    body.classList.add("--js-ready");

    return new Promise((resolve) => {
      anime({
        targets: this.el,
        opacity: 0,
        duration: 1250,
        easing: "linear",
        complete: () => {
          // remove from DOM when completed
          if( this.el ) this.el.remove();

          // resolve transition
          resolve();
        }
      });
    });
  }
}

export default SiteLoader;
